import * as React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';

const useStyles = makeStyles((theme) => ({
  textContent: {
    fontSize: "1.25em"
  }
}));

interface Props {
  content: string;
  confirmButtonText?: string;
  onConfirm: any;
  open: boolean;
  classes: ClassNameMap;
};

const AlertDialog: React.FC<Props> = (prop: Props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Dialog open={prop.open}>
        <DialogContent className={classes.textContent}>
          {prop.content}
        </DialogContent>
        <DialogActions>
          <Button onClick={prop.onConfirm}>{(prop.confirmButtonText || "Okay")}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
export default AlertDialog;